import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React from 'react';

var _excluded = ["as", "className", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ButtonGroup = function ButtonGroup(_ref) {
  var _ref$as = _ref.as,
    As = _ref$as === void 0 ? 'ul' : _ref$as,
    className = _ref.className,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var finalClasses = classnames('C-ButtonGroup', className);
  return /*#__PURE__*/React.createElement(As, _extends({
    className: finalClasses
  }, otherProps), children && children.map(function (child, buttonIndex) {
    // eat destructive or ghost button styles
    if (child.props.type === 'destructive' || child.props.type === 'ghost') {
      var modifiedProps = _objectSpread(_objectSpread({}, child.props), {}, {
        type: 'basic'
      });
      var childToRender = /*#__PURE__*/React.cloneElement(child, modifiedProps);
      console.error("Hey Canvas User! Button type=\"".concat(child.props.type, "\" is not supported in the button group component."));
      return /*#__PURE__*/React.createElement("li", {
        className: "C-ButtonGroup__ListItem",
        key: "listItem_".concat(buttonIndex)
      }, childToRender);
    } else {
      return /*#__PURE__*/React.createElement("li", {
        className: "C-ButtonGroup__ListItem",
        key: "listItem_".concat(buttonIndex)
      }, child);
    }
  }));
};
ButtonGroup.displayName = 'ButtonGroup';

export { ButtonGroup as default };
